module.exports = __webpack_public_path__ + "static/media/lonelypop_game-06-min.d22985c8.png";